import { z } from 'zod';
import { FieldSchema } from '../common';
import { InitialUIElement } from '../initial-ui-element';

export const TAX_ID_PICKER_FIELD_ELEMENT_TYPE = 'taxidpickerfield' as const;
export const TaxIdPickerFieldElementType = z.literal(TAX_ID_PICKER_FIELD_ELEMENT_TYPE);

export const TaxIdPickerFieldParamsSchema = FieldSchema.extend({
  countryCodePath: z.string(),
  optionNotFoundText: z.string().optional(),
});

export type TTaxIdPickerFieldParams = z.infer<typeof TaxIdPickerFieldParamsSchema>;

export const TaxIdPickerFieldElementSchema = InitialUIElement.extend({
  element: TaxIdPickerFieldElementType,
  params: TaxIdPickerFieldParamsSchema,
  valueDestination: z.string(),
});
